export function rotateArray(arrayToRotate, amount) {
    const { length } = arrayToRotate;
    const rotationAmount = amount % length;
    if (rotationAmount === 0) {
        return arrayToRotate.slice();
    }
    return arrayToRotate.map((item, index) => 
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    arrayToRotate[(index + (length + rotationAmount)) % length]);
}
